import Vue from 'vue'
import App from './App.vue'
import router from './router';
import VueYouTubeEmbed from 'vue-youtube-embed'

import "@/assets/icons/css/styles.css";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false

import VueApollo from 'vue-apollo';
Vue.use(VueApollo);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueMoment from 'vue-moment';
import moment from 'moment-timezone'

Vue.use(VueMoment,{
    moment
});
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueYouTubeEmbed)
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
import 'bootstrap-vue/dist/bootstrap-vue.css';

import {apolloClient} from "@/services/apollo";
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// Add a universal router-link directive so you can use it as an attribute
Vue.directive('router-link', {
  inserted: function (el,binding,vnode) {
    el.addEventListener("click",function(){
      vnode.context.$router.push(binding.value);
    })
  }
});

Vue.filter('truncate', (text, length, suffix) => {
  if (!text) return '';
  if (text.length <= length) return text;
  suffix = suffix || '...';
  text = text.toString();
  return text.substring(0, length) + suffix;
});

new Vue({
  apolloProvider,
  router,
  render: h => h(App)
}).$mount('#app')
